import type { SvgIconProps } from "@mui/material/SvgIcon"
import type { Theme, Components } from "@mui/material/styles"

import SvgIcon from "@mui/material/SvgIcon"
import { radioClasses } from "@mui/material/Radio"

// ----------------------------------------------------------------------

/**
 * Icons
 */
export const RadioIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path
            d="M12 2C13.9778 2 15.9112 2.58649 17.5557 3.6853C19.2002 4.78412 20.4819 6.3459 21.2388 8.17317C21.9957 10.0004 22.1937 12.0111 21.8079 13.9509C21.422 15.8907 20.4696 17.6725 19.0711 19.0711C17.6725 20.4696 15.8907 21.422 13.9509 21.8079C12.0111 22.1937 10.0004 21.9957 8.17317 21.2388C6.3459 20.4819 4.78412 19.2002 3.6853 17.5557C2.58649 15.9112 2 13.9778 2 12C2 6.477 6.477 2 12 2ZM12 3.5C9.74566 3.5 7.58365 4.39553 5.98959 5.98959C4.39553 7.58365 3.5 9.74566 3.5 12C3.5 14.2543 4.39553 16.4163 5.98959 18.0104C7.58365 19.6045 9.74566 20.5 12 20.5C14.2543 20.5 16.4163 19.6045 18.0104 18.0104C19.6045 16.4163 20.5 14.2543 20.5 12C20.5 9.74566 19.6045 7.58365 18.0104 5.98959C16.4163 4.39553 14.2543 3.5 12 3.5Z"
            fill="currentColor"
        />
    </SvgIcon>
)

export const RadioCheckedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8Z"
            fill="currentColor"
        />
    </SvgIcon>
)

// ----------------------------------------------------------------------

const MuiRadio: Components<Theme>["MuiRadio"] = {
    /** **************************************
     * DEFAULT PROPS
     *************************************** */
    defaultProps: {
        size: "small",
        icon: <RadioIcon />,
        checkedIcon: <RadioCheckedIcon />,
    },

    /** **************************************
     * STYLE
     *************************************** */
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            padding: theme.spacing(1),
            ...(ownerState.color === "default" && {
                [`&.${radioClasses.checked}`]: { color: theme.vars.palette.text.primary },
            }),
            [`&.${radioClasses.disabled}`]: { color: theme.vars.palette.action.disabled },
        }),
    },
}

// ----------------------------------------------------------------------

export const radio = { MuiRadio }
